import { NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { RouteGroupRule } from '@rocksoft/shared';
import { createVirtualRoomRules } from './virtual-room.rules';

/**
 * Creates all inroom-related SignalR route group rules.
 * Register via SIGNALR_ROUTE_RULES injection token.
 */
export function createInRoomSignalRRules(store: Store, zone: NgZone): RouteGroupRule[] {
  return [...createVirtualRoomRules(store, zone)];
}
